import { useState } from 'react';
import { Maximize2, RotateCcw, Info } from 'lucide-react';
import ChartInteractionDemo from './ChartInteractionDemo';

function ChartHeader({ 
  title, 
  subtitle, 
  chartRef, 
  chartData, 
  onReset, 
  onFullscreen, 
  showResetButton = false,
  showFullscreenButton = false,
  showInfoButton = true, // Default to true for advanced interactions
  onInfoClick,
  containerRef = null,
  className = ""
}) {
  const [showInteractionGuide, setShowInteractionGuide] = useState(false);

  const handleResetClick = () => {
    if (onReset) {
      onReset();
    }
  };

  const handleFullscreenClick = () => {
    if (onFullscreen) {
      onFullscreen();
    }
  };

  const handleInfoClick = () => {
    if (onInfoClick) {
      onInfoClick();
    } else {
      setShowInteractionGuide(true);
    }
  };

  return (
    <>
      <div className={`flex items-center justify-between mb-4 ${className}`}>
        {/* Title Section */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold" style={{ color: 'var(--text)' }}>
            {title}
          </h3>
          {subtitle && (
            <p className="text-sm mt-1" style={{ color: 'var(--muted)' }}>
              {subtitle}
            </p>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          {/* Info Button */}
          {showInfoButton && (
            <button
              onClick={handleInfoClick}
              className="p-2 rounded hover:opacity-80 transition-opacity"
              style={{ 
                background: 'var(--border)', 
                color: 'var(--text)' 
              }}
              title="Chart Information"
            >
              <Info className="w-4 h-4" />
            </button>
          )}

          {/* Reset Button */}
          {showResetButton && (
            <button
              onClick={handleResetClick}
              className="p-2 rounded hover:opacity-80 transition-opacity"
              style={{ 
                background: 'var(--border)', 
                color: 'var(--text)' 
              }}
              title="Reset Chart"
            >
              <RotateCcw className="w-4 h-4" />
            </button>
          )}

          {/* Fullscreen Button */}
          {showFullscreenButton && (
            <button
              onClick={handleFullscreenClick}
              className="p-2 rounded hover:opacity-80 transition-opacity"
              style={{ 
                background: 'var(--border)', 
                color: 'var(--text)' 
              }}
              title="Fullscreen View"
            >
              <Maximize2 className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      {/* Interaction Guide Modal */}
      <ChartInteractionDemo
        isOpen={showInteractionGuide}
        onClose={() => setShowInteractionGuide(false)}
      />
    </>
  );
}

export default ChartHeader;